import type {
  Company,
  CreateDutyRequest,
  DutyRequest,
  DutyRequestListQuery,
  DutyRequestNurse,
  DutyRequestTargetNurse,
  DutyResponse,
  Team,
  UpdateDutyRequest,
  Wanted,
  WorkShift,
} from "dutyon-server/types";
import { httpClient } from "./httpClient";

export type DutyRequestWithRelations = DutyRequest & {
  nurse: DutyRequestNurse;
  team: Team & { company: Company };
  dutyResponses?: DutyResponse[];
  targetNurses?: DutyRequestTargetNurse[];
  wanteds?: Wanted[];
  workShifts?: WorkShift[];
};

export const createDutyRequest = async (
  data: CreateDutyRequest,
  sessionToken?: string,
): Promise<DutyRequest> => {
  const config = sessionToken
    ? { headers: { Authorization: `Bearer ${sessionToken}` }, _retry: true }
    : undefined;
  const response = await httpClient.post<DutyRequest>("/duty-requests", data, config);
  return response.data;
};

export const findAllDutyRequests = async ({
  page = 1,
  limit = 10,
  status,
  teamId,
  startDate,
  endDate,
}: DutyRequestListQuery = {}): Promise<{ list: DutyRequestWithRelations[]; total: number }> => {
  const response = await httpClient.get<{ list: DutyRequestWithRelations[]; total: number }>(
    "/duty-requests",
    {
      params: { page, limit, status, teamId, startDate, endDate },
    },
  );
  return response.data;
};

export const updateDutyRequest = async (
  { id, data }: { id: string; data: UpdateDutyRequest },
  sessionToken?: string,
): Promise<DutyRequest> => {
  const config = sessionToken
    ? { headers: { Authorization: `Bearer ${sessionToken}` }, _retry: true }
    : undefined;
  const response = await httpClient.patch<DutyRequest>(`/duty-requests/${id}`, data, config);
  return response.data;
};

export const findOneDutyRequest = async (id: string): Promise<DutyRequestWithRelations> => {
  const response = await httpClient.get<DutyRequestWithRelations>(`/duty-requests/${id}`);
  return response.data;
};

export const getDutyRequest = findOneDutyRequest;

export const removeDutyRequest = async (id: string): Promise<DutyRequest> => {
  const response = await httpClient.delete<DutyRequest>(`/duty-requests/${id}`);
  return response.data;
};
